module.exports = __webpack_public_path__ + "img/dashboard_administrativo.896c76dd.png";